import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import { useEffect, useState } from "react";
import battleHelper from "../../../API/Battle/battleHelper";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import DashboardScreen from "./DashboardScreen";
const DashboardContainer = () => {
  const [battlesData, setBattlesData] = useState([]);
  const { state } = AppStateManager.useAppStateManager();
  const [dashboardData, setDashboardData] = useState([]);
  const [winsOverTimeData, setWinsOverTimeData] = useState([]);
  const { getActiveWorkspace } = useWorkspaces();
  console.log("DashboardContainer state", state);
  useEffect(() => {
    const fetchData = async (workspaceId) => {
      const data = await battleHelper.getBattlesByWorkspace(workspaceId);
      setBattlesData(data?.data?.ArenaBattlesByWorkspace?.items);
    };
    if (getActiveWorkspace()?.id) fetchData(getActiveWorkspace()?.id);
  }, [getActiveWorkspace()?.id]);
  useEffect(() => {
    if (battlesData?.length > 0) {
      tf_wins = 0;
      tf_draws = 0;

      const agentIdsInBattles = new Set();
      battlesData?.forEach((battle) => {
        if (battle?.firstAgent) agentIdsInBattles.add(battle.firstAgent);
        if (battle?.secondAgent) agentIdsInBattles.add(battle.secondAgent);
      });

      let _leaderBoardAgents = state?.agents
        ?.filter(
          (agent) =>
            ["chatter", "coder", "retriever"].includes(agent?.mode) &&
            agentIdsInBattles.has(agent?.id)
        )
        ?.map((u) => {
          return {
            id: u?.id,
            label: u?.label,
            wins: 0,
            losses: 0,
            draws: 0,
            total_battles: 0,
            total_points: 0,
          };
        });

      const sortedBattles = [...battlesData].sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );

      let total_battles = battlesData?.length;
      battlesData?.map((battle) => {
        let i_f_agent = _leaderBoardAgents
          ?.map((u) => u?.id)
          ?.indexOf(battle?.firstAgent);
        if (i_f_agent === -1) return;
        let f_agent = _leaderBoardAgents[i_f_agent];
        f_agent = {
          ...f_agent,
          total_battles: f_agent?.total_battles + 1,
        };
        _leaderBoardAgents[i_f_agent] = f_agent;

        let i_s_agent = _leaderBoardAgents
          ?.map((u) => u?.id)
          ?.indexOf(battle?.secondAgent);
        if (i_s_agent === -1) return;
        let s_agent = _leaderBoardAgents[i_s_agent];
        s_agent = {
          ...s_agent,
          total_battles: s_agent?.total_battles + 1,
        };
        _leaderBoardAgents[i_s_agent] = s_agent;

        if (battle?.winnerID) {
          if (
            _leaderBoardAgents?.find(
              (agent) => agent?.id == battle?.winnerID
            ) == null
          ) {
            return;
          }
          console.log("Winner", battle?.winnerID);
          let i_w_agent = _leaderBoardAgents
            ?.map((u) => u?.id)
            ?.indexOf(battle?.winnerID);
          let w_agent = _leaderBoardAgents[i_w_agent];
          w_agent = {
            ...w_agent,
            wins: w_agent?.wins + 1,
            total_points: w_agent?.total_points + 1,
          };
          _leaderBoardAgents[i_w_agent] = w_agent;
          tf_wins = tf_wins + 1;
        } else {
          tf_draws = tf_draws + 1;
        }
        total_battles = total_battles + 1;
      });

      const agentsWithActivity = _leaderBoardAgents?.filter(
        (agent) => agent?.total_battles > 0
      );

      const winsOverTime = {};
      sortedBattles?.forEach((battle, index) => {
        const date = new Date(battle.createdAt).toLocaleDateString();
        const prevDate =
          index > 0
            ? new Date(sortedBattles[index - 1].createdAt).toLocaleDateString()
            : null;

        if (!winsOverTime[date]) {
          winsOverTime[date] = {};
          agentsWithActivity?.forEach((agent) => {
            const prevWins =
              prevDate && winsOverTime[prevDate]
                ? winsOverTime[prevDate][agent.id] || 0
                : 0;
            winsOverTime[date][agent.id] = prevWins;
          });
        }

        if (
          battle?.winnerID &&
          winsOverTime[date][battle.winnerID] !== undefined
        ) {
          winsOverTime[date][battle.winnerID] =
            (winsOverTime[date][battle.winnerID] || 0) + 1;
        }
      });

      setWinsOverTimeData(winsOverTime);
      setDashboardData({
        total_battles: total_battles || 0,
        tf_wins: tf_wins || 0,
        tf_losses: 0,
        tf_draws: tf_draws || 0,
        _leaderBoardAgents: agentsWithActivity || [],
      });
    } else {
      setDashboardData({
        total_battles: 0,
        tf_wins: 0,
        tf_losses: 0,
        tf_draws: 0,
        _leaderBoardAgents: [],
      });
      setWinsOverTimeData([]);
    }
  }, [JSON.stringify(battlesData), state?.agents]);
  return <DashboardScreen dashboardData={dashboardData} winsOverTimeData={winsOverTimeData} />;
};

export default DashboardContainer;
